export default __webpack_public_path__ + "static/media/Mask of Crimson Slaughter (nm).338aa552.jpg";